import React, { useEffect, useState } from "react";
import axios from "../../../api/axios.js";
import {
  convertIntoSelect2Options,
  getFetchOptions,
} from "../../../js/utility.js";
import Breadcrumb from "../../utils/Breadcrumb.jsx";
import Select from "react-select";
import { useLocation } from "react-router-dom";

const AddUser = () => {
  const [formData, setFormData] = useState({
    ruolo: "Admin",
    pwd: "123456",
  });
  const [schoolOptions, setSchoolOptions] = React.useState([]);
  const [fullSchoolData, setFullSchoolData] = React.useState([]);
  const [subjectOptions, setSubjectsOptions] = React.useState([]);

  const [loadedData, setLoadedData] = useState(false);
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();

  const rolesOptions = [
    {
      label: "Admin",
      value: "Admin",
    },
  ];

  const breadcrumb = {
    current_section: "Aggiungi utente",
    sections: [
      { name: "Utenti e permessi", route_name: null, params: [] },
      { name: "Nuovo utente", route_name: null, params: [] },
    ],
  };

  const handleSave = async () => {
    if (!formData.telefono || formData.telefono === undefined) {
      formData.telefono = "";
    }

    const fetchOptions = getFetchOptions(
      "application/json",
      { adminData: formData },
      "POST"
    );
    await fetch(`${axios.defaults.baseBFFUrl}/fe/addAdmin`, fetchOptions).then(
      () => {
        window.location = "/users";
      }
    );
  };

  useEffect(() => {
    const fetchSchools = async () => {
      try {
        const fetchOptions = getFetchOptions("application/json", [], "GET");
        const response = await fetch(
          `${axios.defaults.baseBFFUrl}/fe/getAllSchools`,
          fetchOptions
        );
        const result = await response.json();

        const customresult = result.map((item) => {
          return {
            ...item,
            customTown: item.Town.nome + " (" + item.Province.codice + ")",
          };
        });

        setSchoolOptions(
          convertIntoSelect2Options(customresult, "id", [
            "codmiur",
            "denomistituto",
            "customTown",
          ])
        );
        setFullSchoolData(result);
      } catch (error) {
        console.error(error);
      }
    };

    const fetchSubjects = async () => {
      try {
        const fetchOptions = getFetchOptions(
          "application/x-www-form-urlencoded",
          [],
          "GET"
        );
        const response = await fetch(
          `${axios.defaults.baseURL}/materie`,
          fetchOptions
        );
        const result = await response.json();
        setSubjectsOptions(
          convertIntoSelect2Options(result.return.materie, "id", "materia")
        );
      } catch (error) {
        console.error(error);
      }
    };

    Promise.all([fetchSchools(), fetchSubjects()]).then(() => {
      setLoadedData(true);
    });
  }, []);

  useEffect(() => {
    const schoolIdFromUrl = query.get("schoolId");

    if (schoolIdFromUrl && schoolOptions.length > 0) {
      setFormData((prevData) => ({
        ...prevData,
        idscuola: schoolIdFromUrl,
      }));
    }
  }, [loadedData]);

  useEffect(() => {
    if (formData.idscuola) {
      const selectedSchool = fullSchoolData.find(
        (school) => school.id === formData.idscuola
      );

      if (selectedSchool) {
        setFormData({
          ...formData,
          idcomune: selectedSchool.idcomune,
          idprovincia: selectedSchool.idprovincia,
        });
      }
    }
  }, [formData.idscuola]);

  // Funzione per validare il codice fiscale italiano
  const isValidCF = (cf) => {
    if (!cf) return false;
    const regex = /^[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z]$/i;
    return regex.test(cf);
  };

  // Stato per gestire l'errore del codice fiscale
  const [cfError, setCfError] = useState("");

  const isValidEmail = (email) => {
    if (!email) return false;
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const [emailError, setEmailError] = useState("");

  // Modifica handleSave per controllare il codice fiscale
  const handleSaveWithCFCheck = async () => {
    let hasError = false;

    if (!isValidCF(formData.cf)) {
      setCfError("Codice fiscale non valido");
      hasError = true;
    } else {
      setCfError("");
    }

    if (!isValidEmail(formData.email)) {
      setEmailError("Email non valida");
      hasError = true;
    } else {
      setEmailError("");
    }

    if (!formData.nominativo) {
      alert("Il campo Nominativo è obbligatorio.");
      hasError = true;
    }
    if (!formData.idscuola) {
      alert("Il campo Scuola è obbligatorio.");
      hasError = true;
    }

    const checkResponse = await fetch(
      `${axios.defaults.baseBFFUrl}/fe/checkUserEmailAndCF?email=${formData.email}&cf=${formData.cf}&schoolId=${formData.idscuola}`,
      getFetchOptions("application/json", {}, "GET")
    );

    const checkResult = await checkResponse.json();

    if (checkResult.emailExists) {
      setEmailError("Email già utilizzata da un altro insegnante");
      return;
    }
    if (checkResult.cfExists) {
      setCfError("Codice Fiscale già utilizzato da un altro insegnante");
      return;
    }

    if (hasError) return;

    await handleSave();
  };

  return (
    <div className="container-fluid">
      {/* Breadcrumb Component */}
      <Breadcrumb breadcrumb={breadcrumb} />

      <a href="/users">
        <button className="btn btn-primary mb-4">
          <i className="bi bi-arrow-left"></i> Torna alla lista utenti
        </button>
      </a>
      <br />
      <label className="mb-4">
        <b>(*) Campo obbligatorio</b>
      </label>

      {/* General Data Card */}
      <div className="card custom-card">
        <div className="card-header">Dati generali</div>
        <form id="addUserForm">
          <div className="card-body">
            <div className="row row-cols-1 row-cols-lg-3 mb-3">
              <div className="col-6 col-lg-4">
                <label htmlFor="ruolo">Ruolo</label>
                <Select
                  options={rolesOptions}
                  id="ruolo"
                  name="ruolo"
                  defaultValue={"Admin"}
                  value={rolesOptions?.filter(function (option) {
                    return option.value === formData.ruolo;
                  })}
                  onChange={(e) =>
                    setFormData({ ...formData, ruolo: e?.value })
                  }
                  classNames={"form-control"}
                  placeholder="Scegli ruolo..."
                  isDisabled
                />
              </div>
              <div className="col-6 col-lg-8">
                <label htmlFor="idscuola">
                  Scuola <b>*</b>
                </label>
                <Select
                  options={schoolOptions}
                  id="idscuola"
                  name="idscuola"
                  value={schoolOptions?.filter(function (option) {
                    return option.value == formData.idscuola;
                  })}
                  onChange={(e) =>
                    setFormData({ ...formData, idscuola: e?.value })
                  }
                  classNames={"form-control"}
                  placeholder="Scegli scuola..."
                  isSearchable
                  isClearable
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col">
                <label htmlFor="nominativo">
                  Nominativo <b>*</b>
                </label>
                <input
                  className="form-control"
                  id="nominativo"
                  name="nominativo"
                  label="Nominativo"
                  value={formData.nominativo}
                  onChange={(e) =>
                    setFormData({ ...formData, nominativo: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-6 col-lg-4">
                <label htmlFor="email">
                  Email <b>*</b>
                </label>
                <input
                  className={`form-control ${emailError ? "is-invalid" : ""}`}
                  id="email"
                  name="email"
                  label="Email"
                  value={formData.email}
                  onChange={(e) => {
                    setFormData({ ...formData, email: e.target.value });
                    if (emailError) setEmailError("");
                  }}
                />
                {emailError && (
                  <div className="invalid-feedback">{emailError}</div>
                )}
              </div>
              <div className="col-6 col-lg-4">
                <label htmlFor="telefono">Telefono</label>
                <input
                  className="form-control"
                  id="telefono"
                  name="telefono"
                  label="Telefono"
                  value={formData.telefono}
                  onChange={(e) =>
                    setFormData({ ...formData, telefono: e.target.value })
                  }
                />
              </div>
              <div className="col-6 col-lg-4">
                <label htmlFor="cf">
                  Codice fiscale <b>*</b>
                </label>
                <input
                  className={`form-control ${cfError ? "is-invalid" : ""}`}
                  id="cf"
                  name="cf"
                  label="Codice fiscale"
                  value={formData.cf}
                  onChange={(e) => {
                    setFormData({ ...formData, cf: e.target.value });
                    if (cfError) setCfError("");
                  }}
                />
                {cfError && <div className="invalid-feedback">{cfError}</div>}
              </div>
            </div>

            <div className="saveButtonContainer">
              <div
                id="saveTeacherBtn"
                name="saveTeacherBtn"
                className="btn btn-success saveButton"
                role="button"
                onClick={handleSaveWithCFCheck}
              >
                {" "}
                Salva{" "}
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddUser;
